export default __webpack_public_path__ + "static/media/puzzle_3.fbe28b67.png";